"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Export data
var _default = exports.default = {
  domain: '',
  learnMore: {
    logo: {
      alt: 'SAP Logo',
      src: '/sites/all/modules/custom_concur/concur_sap_banner/images/sap-logo.png'
    },
    text: 'A Concur é uma empresa SAP',
    learn: {
      href: '/sap',
      text: 'Saber mais'
    }
  },
  social: [{
    network: 'facebook',
    href: ''
  }, {
    network: 'twitter',
    href: ''
  }, {
    network: 'linkedin',
    href: ''
  }],
  support: {
    links: [{
      text: 'CONCUR BLOG',
      href: ''
    }, {
      text: 'CONTATO',
      href: '/contato'
    }],
    selector: 'Selecionar País/Região',
    modelTitle: 'Select your location:'
  },
  copyright: {
    text: '© Copyright @{year} Concur Technologies, Inc. All rights reserved.',
    links: [{
      text: 'Política de Privacidade',
      href: '/privacy-policy'
    }, {
      text: 'Termos de uso',
      href: ''
    }]
  }
};